import React, { useCallback, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import {
  AUDIENCES,
  audienceLabel,
  getTestimonials,
} from "../../store/actions/councilActions/faqAction";
import BreadCrumb from "../BreadCrumb";
import "./faq.css";

/*
  Testimonials on the website, one section at a time, reached from the same
  tiles as the FAQs:

  /testimonials          the general ones
  /testimonials/student  what students have said, and so on
*/
// A single testimonial. Long messages are clamped with a "Read more" toggle so
// every card in a row stays the same, tidy height.
const LIMIT = 220;
const TmCard = ({ row }) => {
  const [open, setOpen] = useState(false);
  const msg = String(row.message || "");
  const long = msg.length > LIMIT;
  const shown = open || !long ? msg : msg.slice(0, LIMIT).trimEnd() + "…";

  return (
    <div class="tm-card">
      {row.rating ? (
        <div class="tm-stars">
          {"★".repeat(Number(row.rating))}
          {"☆".repeat(5 - Number(row.rating))}
        </div>
      ) : null}

      <div class={`tm-msg ${open ? "open" : ""}`}>{shown}</div>
      {long && (
        <button
          type="button"
          class="tm-readmore"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? "Read less" : "Read more"}
        </button>
      )}

      <div class="tm-who">
        {row.photo ? (
          <img src={row.photo} alt={row.name} />
        ) : (
          <div class="tm-initial">
            {String(row.name || "?").trim().charAt(0).toUpperCase()}
          </div>
        )}
        <div>
          <div class="tm-name">{row.name}</div>
          {row.designation && <div class="tm-desig">{row.designation}</div>}
        </div>
      </div>
    </div>
  );
};

const Testimonials = () => {
  const dispatch = useDispatch();
  const { audience } = useParams();

  const section = AUDIENCES.some((a) => a.key === audience)
    ? audience
    : "general";

  const [list, setList] = useState(null);
  const [counts, setCounts] = useState({});

  const load = useCallback(async () => {
    setList(null);
    const { list: rows, counts: totals } = await dispatch(
      getTestimonials({ active: 1, audience: section })
    );
    setList(rows);
    setCounts(totals);
  }, [dispatch, section]);

  useEffect(() => {
    load();
  }, [load]);

  const breadcrumbs = [
    { path: "/", label: "Home" },
    { label: `${audienceLabel(section)} Testimonials` },
  ];

  return (
    <div class="lists-box">
      <div class="container">
        <BreadCrumb crumbs={breadcrumbs} />

        <div class="title-box">
          <h4>{audienceLabel(section)} Testimonials</h4>
        </div>

        <div class="faq-sections">
          {AUDIENCES.map((a) => (
            <Link
              key={a.key}
              class={`faq-chip ${a.key === section ? "active" : ""}`}
              to={`/testimonials/${a.key}`}
            >
              {a.label} <span>({counts[a.key] ?? 0})</span>
            </Link>
          ))}
        </div>

        {list === null ? (
          <div class="text-center my-5">
            <Spinner animation="border" />
          </div>
        ) : list.length === 0 ? (
          <p class="my-5 text-center">Nothing has been added here yet.</p>
        ) : (
          <div class="row my-4">
            {list.map((row) => (
              <div class="col-lg-4 col-md-6 mb-4" key={row.id}>
                <TmCard row={row} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Testimonials;
